// extracted by mini-css-extract-plugin
export default {"separatorLine":"fwM5Op7exM1xmWP3K71q"};